import { VF_MULTI_SELECT } from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  NONE_AFFECTED,
} from 'AppSrc/core/components/forms/value-dependency-constants';


const fieldId = 'critical_customer_list';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_MULTI_SELECT);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select affected customers, if none affected or unsure - select None affected' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = null;

const vFParams = {
  fieldTitle: 'Critical customer list',
  placeholder: 'Company name',
  // displays at the top and clears the selection if selected, replacing the fields value with it's values
  overridingOptions: [
    {
      text: 'None affected',
      values: [NONE_AFFECTED],
      id: 'none_affected',
      // if this option duplicates an existing display option, we need to filter that out of the displayOptions
      // using duplicatesValue. ie, for an overridingOption that clears all selected values and sets the value as
      // NONE_AFFECTED, we would need to exclude NONE_AFFECTED from the list of displayOptions
      duplicatesDisplayOptionWithValue: NONE_AFFECTED,
    },
  ],
};

const criticalCustomerList = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_MULTI_SELECT,
};

export { criticalCustomerList };
